import { FC, ReactNode } from 'react';
import { Col, Row, Text } from '@keyslabor/shared/ui';
import { FlagSpain, FlagUsa } from '@/assets/index';
import { Language } from '@/api/types';
import {
  LANGUAGE_LABEL,
  splitPrimaryAndSecondaryLanguages,
} from '@/lib/language';
import { FlagUkraine } from '@/assets';

const languageContent: Record<Language, ReactNode> = {
  english: (
    <>
      <FlagUsa />
      <Text fontWeight="800" fontSize="18px" upper>
        {LANGUAGE_LABEL.english}
      </Text>
    </>
  ),
  spanish: (
    <>
      <FlagSpain />
      <Text fontWeight="800" fontSize="18px" upper>
        {LANGUAGE_LABEL.spanish}
      </Text>
    </>
  ),
  russian: (
    <Text fontWeight="800" fontSize="14px" upper>
      {LANGUAGE_LABEL.russian}
    </Text>
  ),
  ukrainian: (
    <>
      <FlagUkraine className="rounded-full size-[110px]" />
      <Text fontWeight="800" fontSize="14px" upper>
        {LANGUAGE_LABEL.ukrainian}
      </Text>
    </>
  ),
};

interface LanguageOptionsListProps {
  languages: Language[];
  onSelect: (language: Language) => void;
  primaryMarginTop?: string;
  secondaryMarginTop?: string;
  gap?: string;
}

const LanguageOption: FC<{
  language: Language;
  onSelect: (language: Language) => void;
}> = ({ language, onSelect }) => {
  return (
    <Row
      gap="20px"
      flexCenter
      css="cursor: pointer;"
      onClick={() => onSelect(language)}
    >
      {languageContent[language]}
    </Row>
  );
};

export const LanguageOptionsList: FC<LanguageOptionsListProps> = ({
  languages,
  onSelect,
  primaryMarginTop = '40px',
  secondaryMarginTop = '48px',
  gap = '48px',
}) => {
  const [primaryLanguages, secondaryLanguages] =
    splitPrimaryAndSecondaryLanguages(languages);

  return (
    <>
      <Col gap={gap} mt={primaryMarginTop}>
        {primaryLanguages.map((language) => (
          <LanguageOption
            key={language}
            language={language}
            onSelect={onSelect}
          />
        ))}
      </Col>
      {secondaryLanguages.map((language) => (
        <Col gap={gap} mt={secondaryMarginTop} key={language}>
          <LanguageOption language={language} onSelect={onSelect} />
        </Col>
      ))}
    </>
  );
};
